export const MATHEMATICS_CHARACTER_MAP_ICON = 'Ω';

export const MATHEMATICS_CHARACTER_MAPS = [
  '°',
  '∞',
  '≤',
  '≥',
  '≠',
  '≈',
  'π',
  'Δ',
  'Σ',
  'Χ',
  'α',
  'β',
  'ε',
  'θ',
  'κ',
  'λ',
  'μ',
  'ν',
  'ρ',
  'σ',
  'τ',
  'ω',
  'x̄',
  'p̂',
  'ŷ',
  '→',
  '⇄',
];
